import { ButtonDesignTokens } from '@primeuix/themes/types/button'

// Design tokens to better match bootstrap buttons FOR NOW until we migrate to prime vue..
// the pv buttons were looking too different compared to bv buttons so i put this in the global sheet until we can swap out everything
const index: ButtonDesignTokens = {
  root: {
    paddingX: '0.75rem',
    paddingY: '0.375rem',
    label: {
      fontWeight: '400'
    }
  },
  colorScheme: {
    light: {
      root: {
        secondary: {
          background: '{primary.50}',
          hoverBackground: '{primary.100}',
          activeBackground: '{primary.100}',
          borderColor: '{primary.50}',
          hoverBorderColor: '{primary.100}',
          activeBorderColor: '{primary.100}',
          color: '{surface.700}',
          hoverColor: '{surface.800}',
          activeColor: '{surface.800}'
        },
        warn: {
          background: '{warning.100}',
          hoverBackground: '{warning.200}',
          activeBackground: '{warning.200}',
          borderColor: '{warning.100}',
          hoverBorderColor: '{warning.200}',
          activeBorderColor: '{warning.200}',
          color: '{warning.800}',
          hoverColor: '{warning.900}',
          activeColor: '{warning.900}',
          focusRing: {
            color: '{warning.200}',
            shadow: 'none'
          }
        },
        danger: {
          background: '{danger.100}',
          hoverBackground: '{danger.300}',
          activeBackground: '{danger.300}',
          borderColor: '{danger.100}',
          hoverBorderColor: '{danger.300}',
          activeBorderColor: '{danger.300}',
          color: '{danger.800}',
          hoverColor: '{danger.900}',
          activeColor: '{danger.900}',
          focusRing: {
            color: '{danger.200}',
            shadow: 'none'
          }
        },
        info: {
          background: '{info.100}',
          hoverBackground: '{info.200}',
          activeBackground: '{info.200}',
          borderColor: '{info.100}',
          hoverBorderColor: '{info.200}',
          activeBorderColor: '{info.200}',
          color: '{info.800}',
          hoverColor: '{info.900}',
          activeColor: '{info.900}',
          focusRing: {
            color: '{info.200}',
            shadow: 'none'
          }
        },
        success: {
          background: '{success.100}',
          hoverBackground: '{success.200}',
          activeBackground: '{success.200}',
          borderColor: '{success.100}',
          hoverBorderColor: '{success.200}',
          activeBorderColor: '{success.200}',
          color: '{success.800}',
          hoverColor: '{success.900}',
          activeColor: '{success.900}',
          focusRing: {
            color: '{success.200}',
            shadow: 'none'
          }
        },
        contrast: {
          background: '{surface.700}',
          hoverBackground: '{surface.800}',
          activeBackground: '{surface.800}',
          borderColor: '{surface.700}',
          hoverBorderColor: '{surface.800}',
          activeBorderColor: '{surface.800}',
          color: '{surface.0}',
          hoverColor: '{surface.0}',
          activeColor: '{surface.0}',
          focusRing: {
            color: '{success.200}',
            shadow: 'none'
          }
        }
      },
      link: {
        color: '{primary.700}',
        hoverColor: '{primary.800}'
      },
      outlined: {
        primary: {
          color: '{surface.700}'
        }
      },
      text: {
        primary: {
          color: '{surface.700}'
        }
      }
    }
  }
}

export { index as default }
